document.addEventListener('DOMContentLoaded', function () {
    initializeMobileMenu();

    function initializeMobileMenu() {
        const offCanvasBtn = document.getElementById('off-canvas-btn');
        const mobileMenu = document.getElementById('mobile-menu');
        const mobileMenuClose = document.getElementById('mobile-menu-close');
        const menuLinks = document.querySelectorAll('#mobile-menu-nav a');

        if (!offCanvasBtn || !mobileMenu || !mobileMenuClose) {
            return;
        }

        function openMenu() {
            mobileMenu.classList.add('open-menu');
        }

        function closeMenu() {
            mobileMenu.classList.remove('open-menu');
        }

        offCanvasBtn.addEventListener('click', openMenu);
        mobileMenuClose.addEventListener('click', closeMenu);

        menuLinks.forEach(link => {
            link.addEventListener('click', closeMenu);
        });

        window.addEventListener('click', function(event) {
            if (!mobileMenu.contains(event.target) && !offCanvasBtn.contains(event.target)) {
                closeMenu();
            }
        });
    }
});

jQuery(document).ready(function ($) {
    let firstItem = $(".js-accordion-item").first();
    firstItem.addClass("open").find(".js-accordion-content").show();

    $("body").on("click", ".js-accordion-item-title", function() {
        let parentItem = $(this).closest(".js-accordion-item");

        if (parentItem.hasClass("open")) {
            parentItem.removeClass("open").find(".js-accordion-content").slideUp();
        } else {
            $(".js-accordion-item.open")
                .removeClass("open")
                .find(".js-accordion-content")
                .slideUp();

            parentItem.addClass("open").find(".js-accordion-content").slideDown();
        }
    });
});